import { Badge } from "@similarweb/ui-components";

/** Marks a permanently released capability. `type="new"` carries its own "NEW" copy — no children, no key. */
export const NewBadge = () => {
    return <Badge type="new" />;
};
